<template>
</template>

<script>
  export default{
    data(){
      return{
				code:""
      }
    },
    created() {
			
      let token = localStorage.getItem('token')
			var query = this.$route.query;
			this.code = query.code
			console.log(query);
			// window.close()
			if(!this.code){
				let url = encodeURIComponent('https://www.doudshou.com/#/wx_login')
				let appid = 'wx5c3246e6d88bd66d'
				
				let wxurl = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + appid + '&redirect_uri='+url+'&response_type=code&scope=snsapi_login&state=#wechat_redirect'
				window.location.href = wxurl
			}else{
				localStorage.setItem("code",this.code)
				console.log(this.code);
			}

			// if(!token){
				
			// }
    },
		updated() {
			console.log("执行了");
		}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/login/wx_login.vue